import React from 'react';
import Loading from './Loading';
import Choices from './Choices';
import './Action.scss';

function Action ({count,lastCount,choices,retry,submit,addSelected,isLoading}){
	return (
    <div id="action">
        {count>0 && count<=lastCount &&
        <Choices list={choices[count-1]} addSelected={addSelected}/>
        }
        {count===lastCount+1 &&
        <div className="confirm">
            <button className="no" onClick={retry}>やりなおし</button>
            <button className="yes" onClick={submit}>これでいい</button>
        </div>
        }
        {isLoading &&
        <Loading/>
        }
    </div>
    );
}

export default Action;
